import { AdminTriathlonPanel } from '@/components/AdminTriathlonPanel';
import { SecurityTestSuite } from '@/components/SecurityTestSuite';
import { AdminSecurityDashboard } from '@/components/AdminSecurityDashboard';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useAdminAuth } from '@/hooks/useAdminAuth';

interface AdminPanelProps {
  onAdminModeChange: (isAdminMode: boolean) => void;
  isAdminMode: boolean;
  showSecurityDashboard: boolean;
  onSecurityDashboardChange: (show: boolean) => void;
}

export const AdminPanel = ({ onAdminModeChange, isAdminMode, showSecurityDashboard, onSecurityDashboardChange }: AdminPanelProps) => {
  const { isAdmin } = useAdminAuth();
  const [showSecurityTestSuite, setShowSecurityTestSuite] = useState(false);
  
  // Only render if user is admin
  if (!isAdmin) {
    return null;
  }

  return (
    <>
      {/* Security Dashboard Overlay */}
      {showSecurityDashboard && (
        <div className="fixed inset-0 bg-background/95 backdrop-blur z-[70] p-4 overflow-y-auto">
          <div className="max-w-6xl mx-auto space-y-6">
            <div className="flex justify-between items-center">
              <h1 className="text-2xl font-light">Admin Security Dashboard</h1>
              <Button
                onClick={() => onSecurityDashboardChange(false)}
                variant="outline"
              >
                Close
              </Button>
            </div>
            <AdminSecurityDashboard />
          </div>
        </div>
      )}

      {/* Admin Dashboard Overlay */}
      {isAdminMode && (
        <div className="fixed inset-0 bg-background/95 backdrop-blur z-[50] p-4 overflow-y-auto">
          <div className="max-w-6xl mx-auto space-y-6">
            <div className="flex justify-between items-center">
              <h1 className="text-2xl font-light">Admin Dashboard</h1>
              <Button
                onClick={() => onAdminModeChange(false)}
                variant="outline"
              >
                Exit Admin Mode
              </Button>
            </div>
            <AdminTriathlonPanel />
            <Button 
              onClick={() => setShowSecurityTestSuite(true)} 
              className="w-full"
            >
              Open Security Test Suite
            </Button>
          </div>
        </div>
      )}

      {/* Security Test Suite Modal */}
      {showSecurityTestSuite && (
        <SecurityTestSuite onClose={() => setShowSecurityTestSuite(false)} />
      )}
    </>
  );
};